import type { SiteConfig } from '../../@types/context/site-config.types';

export const serviceTrustpilotAxoConfig: Pick<
  SiteConfig['services']['trustpilot'],
  'id'
> = {
  id: '539adbd6dec7e10e686debee',
};
